const ReportsEmptyState = ({ learnerPlural = "students" }) => (
    <section className="reports-empty-state">
        <h3>No reading activity yet 📚</h3>
        <p>{`Once ${learnerPlural} complete reading assignments, their progress will appear here.`}</p>
    </section>
);

export default ReportsEmptyState;
